import React, { Fragment } from "react";
import Enquires from "./index";


const EnquireCollection = ({ data, type }) => {
  return (
    <> {
        data.map((item, i) => (
            <Fragment key={i}>
                {type === 'text' && (
                    <Enquires
                        inputTitle={item.inputTitle}
                        title={item.title}
                      />
                )}
            </Fragment>
        ))
     } 
    </>
)
};

export default EnquireCollection;
